<template>
  <div class="skip-container">
    <div class="skip-content">
      <i class="el-icon-loading" />
      <p class="skip-text">正在安全登录，请稍候...</p>
    </div>
  </div>
</template>

<script>
import { postData } from '@/api/ik/data/dataApi'

export default {
  name: 'Skip',
  data() {
    return {
      timer: null
    }
  },
  created() {
    this.autoLogin()
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    autoLogin() {
      const query = this.$route.query
      const usercode = query.usercode
      const password = query.password
      const url = query.url || query.redirect || '/base/home'

      if (!usercode || !password) {
        this.$message.error('登录参数缺失，请使用正确的登录链接')
        this.timer = setTimeout(() => {
          this.$router.replace('/dc/admin/login')
        }, 1500)
        return
      }

      let type = '1'
      if (usercode.length === 13) {
        type = '2'
      }

      const pd = {
        code: usercode,
        password: password,
        type: type
      }

      postData('base/user/user/storeuser/do/storelogin', pd)
        .then(response => {
          this.$store.dispatch('user/login', {
            'token': response.data.token,
            'userCode': response.data.code,
            'userName': response.data.name,
            'userRole': response.data.userRole,
            'storeId': response.data.storeId,
            'storeCode': response.data.storeCode,
            'storeName': response.data.storeName,
            'securityLevel': '',
            'fieldSecurityLevel': '',
            'doctorType': response.data.doctorType,
            'pharmacistType': response.data.pharmacistType,
            'baseUserId': response.data.baseUserId
          })
          localStorage.setItem('user', JSON.stringify(this.$store.state.user))

          // 非首页跳转时标记全屏模式（关闭浏览器后自动失效）
          if (url && url !== '/base/home') {
            sessionStorage.setItem('hideLayout', '1')
            sessionStorage.setItem('hideLayoutPath', url)
          }

          this.$router.replace({ path: url })
        })
        .catch(() => {
          this.$message.error('登录失败，请检查链接或手动登录')
          this.timer = setTimeout(() => {
            // 失败时不带参数，防止死循环
            this.$router.replace('/dc/admin/login')
          }, 1500)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.skip-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;

  .skip-content {
    text-align: center;

    .el-icon-loading {
      font-size: 48px;
      color: #026CFF;
      margin-bottom: 20px;
    }

    .skip-text {
      font-size: 16px;
      color: #666;
      font-family: PingFang SC, sans-serif;
    }
  }
}
</style>
